<template>
  <div class="Site PageBox" >
    <van-nav-bar
      fixed
      :border="false"
      left-arrow
      @click-left="$router.push('/login')"
      :right-text="$t('language')"
      @click-right="$router.push('/language')"
    />
    <div class="Login ScrollBox" :style="{backgroundImage: 'url('+InitData.setting.login_bg_img+')',backgroundSize:'100% 100%'}">
       <div style=" width:341px; height:481px;margin:8px auto;background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 16px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);">
      </div>
      <div style="z-index: 1000; top: 158px;left: 65px; position: absolute;left: 0; right: 0;bottom: 0;margin: auto;width: 310px;">
      <van-form @submit="onSubmit" style="padding-top: 15px;">
        <van-field
          type="text"
          autocomplete="off"
          style="height: 0;width: 0;padding: 0;position: absolute"
        />
        <van-field
          type="password"
          autocomplete="off"
          style="height: 0;width: 0;padding: 0;position: absolute"
        />
        <van-field
          left-icon="manager"
          clearable
          :border="false"
        >
          <template #input>
            <van-dropdown-menu>
				<!-- <span >{{postData.dest}}</span> -->
              <van-dropdown-item :title="postData.dest" ref="DropdownItem">
                <template>
                  <ul>
                    <li v-for="item in areaList" :key="item.id" :class="{on:postData.dest==item.id}" @click="postData.dest=item.id,$refs.DropdownItem.toggle()">{{item.id}}&#12288;{{item.name}}</li>
                  </ul>
                </template>
              </van-dropdown-item>
            </van-dropdown-menu>
            <input type="tel" v-model.trim="postData.username" :placeholder="$t('register.placeholder[0]')"  style="border:0;flex:1;width:100px;padding-left: 50px;background: transparent">
          </template>
        </van-field>

        <van-field
          left-icon="coupon"
          v-model.trim="postData.code"
          autocomplete="off"
          type="digit"
          :placeholder="$t('register.placeholder[6]')"
          clearable
          :border="false"
		      style="line-height: 2rem;"
        > 
          <template #button>
            <van-image width="100" height="34" :src="captchaImage" style="display: block;cursor: pointer;" @click="getCode" />
          </template>
        </van-field>

        <van-field
          left-icon="coupon"
          v-model.trim="postData.smscode"
          autocomplete="off"
          type="digit"
          :placeholder="$t('register.placeholder[1]')"
          clearable
          :border="false"
          v-if="InitData.setting.is_sms==1"
          style="line-height: 1.5rem;"
        >
          <template #button>
            <van-button size="mini" type="danger" round native-type="button" @click="getSmsCode" :loading="isSendCode" :loading-text="$t('register.text[1]')">{{$t('register.text[2]')}}</van-button>
          </template>
        </van-field>

        <van-field
          left-icon="lock"
          :type="showPass1?'text':'password'"
          v-model.trim="postData.password"
          :placeholder="$t('register.placeholder[2]')"
          clearable
          autocomplete="off"
          :border="false"
          style="line-height: 1.5rem;"
         :right-icon="showPass1?'eye':'closed-eye'"
          @click-right-icon="showPass1=!showPass1"
        />
        <van-field
          left-icon="lock"
         :type="showPass2?'text':'password'"
          v-model.trim="postData.re_password"
          :placeholder="$t('register.placeholder[3]')"
          clearable
          autocomplete="off"
          :border="false"
          style="line-height: 1.5rem;"
          :right-icon="showPass2?'eye':'closed-eye'"
          @click-right-icon="showPass2=!showPass2"
        />
        <van-field
          left-icon="invition"
          :readonly="recommendDis"
          v-model.trim="postData.recommend"
          :placeholder="$t('register.placeholder[4]')"
          clearable
          autocomplete="off"
          :border="false"
          style="line-height: 1.5rem;"
        />
        <div style="display: flex;flex-direction: row;">
          <van-button round :loading="isSubmit" :loading-text="$t('register.text[3]')" style="font-size: 18px;background-color: #37774C;border:none; width: 100%;">{{$t('register.text[4]')}}</van-button>
        </div>
        <van-button size="large" block plain type="info" round style="font-size: 18px;margin-top: 10px;background: transparent;" @click="goDown"  >{{$t('register.text[5]')}}</van-button>
      </van-form>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Register',
  components: {
    
  },
  props: ['recommendId'],
  data() {
    return {
      postData: {
        dest: '',
        username: '',
        password: '',
        re_password: '',
        smscode: '',
        code: '',
        code_rand: '',
        recommend: this.recommendId||''
      },
      recommendDis: this.recommendId?true:false,
      areaList: [{'id':'+381'},{'id':'+992'}],
      isSendCode: false,
      isSubmit: false,
      codeImg: '',
      showBrowserTips: false,
      downUrl: '',
      isPlus: false,
      showPass1: false,
      showPass2: false,
      captchaImage:''
    }
  },
  computed: {
  
  },
  watch: {

  },
  created() {
   
    
   // this.$Model.SmsCode((data) => {
   //    this.areaList = data
   //    this.postData.dest = data[0].id
   //  })
    this.postData.dest = this.InitData.setting.area_code
    this.getCode()
    this.checkUserAgent()
  },
  mounted() {
    if(window.plus){
      this.isPlus = true
    }
  },
  activated() {

  },
  destroyed() {

  },
  methods: {
	handleInput(event) {
		var val = event.target.value;
		val = val.replace(/\D/g, '');
		if(val!=0) {
			
		} else {
			this.$Dialog.Toast(this.$t('register.placeholder[8]'));
			this.postData.username = '';
		}
	},
    goDown() {
      // const u = navigator.userAgent;
      // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      // if (isiOS) {
      // 	this.$Util.OpenUrl(this.InitData.setting.ios_url);
      // } else {
      // 	this.$Util.OpenUrl(this.InitData.setting.h_server_name);
      // }
	  this.$router.push(`/login`);
    },

    getCode() {
      this.postData.code_rand = new Date().getTime()
      // this.codeImg = this.ApiUrl+'/Account/code?code_rand='+this.postData.code_rand
      // 发起请求，携带code_rand参数
      axios.get(this.ApiUrl+'/Account/code', {
          params: {
            code_rand: this.postData.code_rand
          }
        })
        .then(response => {
          // 拼接Data URL
          this.captchaImage = 'data:image/png;base64,' + response.data;
        })
        .catch(error => {
          console.error('获取验证码失败:', error);
        });
    },
    onSubmit() {
      if(!this.postData.username){
        this.$Dialog.Toast(this.$t('register.placeholder[0]'))
        return
      }
      // if(!this.postData.recommend){
      //   this.$Dialog.Toast(this.$t('register.placeholder[4]'))
      //   return
      // }
      if(!this.postData.smscode&&this.InitData.setting.is_sms==1){
        this.$Dialog.Toast(this.$t('register.placeholder[1]'))
        return
      }
      if(!this.postData.code&&this.InitData.setting.is_sms==2){
        this.$Dialog.Toast(this.$t('register.placeholder[6]'))
        return
      }
      if(!this.postData.password){
        this.$Dialog.Toast(this.$t('register.placeholder[2]'))
        return
      }
      if(!this.postData.re_password){
        this.$Dialog.Toast(this.$t('register.placeholder[3]'))
        return
      }
      if(this.postData.password!=this.postData.re_password){
        this.$Dialog.Toast(this.$t('register.placeholder[5]'))
        return
      }
      this.isSubmit = true
      this.$Model.UserRegister(this.postData,data=>{
        this.isSubmit = false
        this.getCode()
      });
    },
    getSmsCode() {
      /* if(!this.postData.username){
        this.$Dialog.Toast(this.$t('register.placeholder[0]'))
        return
      }
      // if(!this.postData.recommend){
      //   this.$Dialog.Toast(this.$t('register.placeholder[4]'))
      //   return
      // }
      if(!this.postData.code){
        this.$Dialog.Toast(this.$t('register.placeholder[6]'))
        return
      }
      this.isSendCode = true
      this.$Model.GetSMSCode({phone: this.postData.username,dest: this.postData.dest, code: this.postData.code, recommend: this.postData.recommend, code_rand: this.postData.code_rand},(data)=>{
        this.isSendCode = false;
      }) */
    },
    checkUserAgent(callback) {
      var ua = navigator.userAgent;
      var is_WeiXin = ()=> {
        if (/(MicroMessenger)/.test(ua)) {
          return true;
        }
        return false;
      };
      var is_QQ = ()=> {
        if (/(QQ)/.test(ua)) {
          return true;
        }
        return false;
      };
      var is_Android = ()=> {
        if (/(Android)/.test(ua)) {
          return true;
        }
        return false;
      };
      var is_iOS = ()=> {
        if (/(iPod|iPhone|iPad)/.test(ua)) {
          return true;
        }
        return false;
      };
      if(is_WeiXin()){
        this.showBrowserTips = true;
      }
      if(is_iOS()){
        callback&&callback('IOS');
      }else{
        callback&&callback('Android');
      }
    },
  }
}
</script>

<style scoped>
.van-dropdown-menu{
  position: absolute;
  left: 0;
}
.van-dropdown-menu >>> .van-dropdown-item__content{
    inset: 21px;
    margin: -10px auto;
    width: 295px;
    height: 70px;
}
.van-dropdown-menu >>> .van-overlay{
  background-color:unset;
}
.van-dropdown-menu>>>.van-dropdown-menu__bar{
  height: auto;
  box-shadow: none;
  background: transparent;
}
.van-dropdown-menu>>>.van-dropdown-menu__title{
  padding: 0 10px 0 0;
  margin-right: 10px;
  color: #888;
}
.van-dropdown-menu>>>.van-dropdown-item__content ul{
  padding: 0 15px;
}
.van-dropdown-menu>>>.van-dropdown-item__content ul li{
  padding: 8px 0;
  width: 100%;
  font-size: 14px;
}
.van-dropdown-menu>>>.van-dropdown-item__content ul li.on{
  color: #37774C;
}
.van-dropdown-menu>>>.van-dropdown-item__content ul li+li{
  border-top: 1px #f5f5f5 solid;
  color: #333;
}
.BrowserTips{
  background-color: rgba(0, 0, 0, .8);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: right;
  z-index: 99999
}
.van-nav-bar>>>.van-nav-bar__text{
  color: #fff;
}
.ScrollBox .van-form .van-field {
    background-color: #fff!important;
    border-radius: 0;
    box-shadow: none;
    border:none;
    border-bottom: 1px solid rgba(0, 0, 0, .1);
    margin-bottom: .65rem;
    margin: 0 auto;
    margin-bottom: 1rem;
    border-radius:8px;
}
.Login{
  padding-top: 135px;
}
/deep/ .van-button--info{border:1px solid #fff;}
/deep/ .van-button--plain.van-button--info{color:#fff}
</style>